export default "__VITE_ASSET__BBFWQFAB__"